import React, { useState, useEffect } from 'react';
import { Menu } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import VersionFigure from '@/pages/home/components/VersionPopup/VersionFigure';
import VersionImg from '@/pages/home/components/VersionPopup/VersionImg';
import {
  isJSONFormartStr,
  VersionItemLocaleType,
  sysTypeOrEnvType,
  getSysEvnType,
  VersionItemType,
  getTranslateVersionInfo,
} from '@/pages/home/components/VersionPopup/_config';
import { getVersionInfo } from '@/pages/home/services/versionPopup';
import { getLocale } from 'umi';
import './index.scss';

interface IVersionRecord {
  id: string;
  version: string;
  releaseDate: string;
  description: string;
  changes: string[];
}

const PicContext = (props: any) => {
  const { sysType, versionName, versionContent } = props;

  if (sysType === sysTypeOrEnvType.sys_type_globalPedia)
    return (
      <VersionFigure
        versionName={versionName}
        versionContent={versionContent}
      />
    );

  return (
    <div className="details-right">
      <div className="details-right-date">{versionName}</div>
      <VersionImg versionName={versionName} versionContent={versionContent} />
    </div>
  );
};

const TextContext = (props: any) => {
  const { versionName, versionContent } = props;
  return (
    <div className="details-other-right">
      <div className="details-title">{versionName}</div>
      <div
        className="details-text"
        dangerouslySetInnerHTML={{ __html: versionContent }}
      ></div>
    </div>
  );
};

const VersionHistory: React.FC = () => {
  const sysEnv = getSysEvnType();
  const locale = getLocale();
  const [loading, setLoading] = useState(false);
  const [versionList, setVersionList] = useState<IVersionRecord[]>([]);
  const [activeVersionInfo, setActiveVersionInfo] =
    useState<VersionItemLocaleType | null>(null);

  // 获取版本历史数据
  const getVersionList = async () => {
    setLoading(true);
    try {
      const params = {
        sys_env: sysEnv,
      };
      const res = await getVersionInfo(params);
      const versionsList = res?.version_list || [];
      const menuList: any = [];
      versionsList.forEach((t: VersionItemType) => {
        if (t?.sys_type === 4) {
          const localeVersion = getTranslateVersionInfo(t, locale);
          menuList.push(localeVersion);
        }
      });
      setVersionList(menuList);
      setActiveVersionInfo(menuList[0] || null);
      // setError(false);
    } catch (e) {
      console.error(e);
      // setError(true);
    }
    setLoading(false);
  };

  useEffect(() => {
    getVersionList();
  }, []);

  const getMenuItemProps = (sysType: number, t: any) => {
    const id = `${sysType}-${t.version_name}`;
    const lastActiveId = `4-${activeVersionInfo?.version_name}`;
    return {
      selected: lastActiveId === id,
      onClick: () => {
        setActiveVersionInfo(t);
      },
    };
  };

  return (
    <div className="dbg-version-history">
      <div className="dbg-version-history-header">
        <div className="dbg-version-history-header-title">Version History</div>
      </div>
      <div className="version-details-context">
        <div className="details-left">
          <Menu className="details-left-menu">
            <Menu.SubMenu
              key={'gp-version-details'}
              title={
                <div className="menu-flex">
                  <SvgIcon type={'search-gp-btn'} className="menu-icon" />
                  {'G-GOP'}
                </div>
              }
              defaultOpened={true}
              opened={true}
            >
              {!versionList?.length ? null : (
                <>
                  {versionList?.map((t: any) => {
                    return (
                      <Menu.Item
                        className="menu-text"
                        key={t?.version_name}
                        title={
                          <div className="menu-overflow">{t?.version_name}</div>
                        }
                        {...getMenuItemProps(4, t)}
                      />
                    );
                  })}
                </>
              )}
            </Menu.SubMenu>
          </Menu>
        </div>
        {!loading &&
          (isJSONFormartStr(activeVersionInfo?.version_content || '') ? (
            <PicContext
              sysType={4}
              versionName={activeVersionInfo?.version_name}
              versionContent={activeVersionInfo?.version_content}
            />
          ) : (
            <TextContext
              versionName={activeVersionInfo?.version_name}
              versionContent={activeVersionInfo?.version_content}
            />
          ))}
      </div>
    </div>
  );
};

export default VersionHistory;
